export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13639.29bb4f71.jpg";